import React from 'react';
import autobind from 'autobind-decorator';

import { PureComponent, Page } from 'core/components';
import { withLocale } from 'core/decorators';
import { ForgetPassword } from 'content/components';

import translations from './i18n';

class ForgetPasswordPage extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      items: []
    };

    this.props.translator.addModuleResource('forget_password', translations);
  };

  /**
   * handle loading
   * @param {Boolian} loading 
   */
  loading(loading = false) {
    this.setState((prevState, props) => {
      return { loading: loading }
    });
  };

  render() {
    const { id, navigate } = this.props;

    return (
      <Page
        pageName="forgetPassword"
        showBack={true}
        navigate={navigate}>

        <ForgetPassword
          id={id}
          navigate={navigate}
        />

      </Page>
    );
  };
};

export default withLocale('forget_password')(autobind(ForgetPasswordPage));
